import { Box, BoxProps, CSSObject, useStyleConfig } from '@chakra-ui/react';

export interface CardProps extends BoxProps {
  cardProps?: CSSObject;
  variant?: 'rounded' | 'smooth' | 'shadow' | 'ghost';
}

export const Card = (props: CardProps) => {
  const { children, cardProps, ...rest } = props;
  const styles = useStyleConfig('Card', { ...rest });

  return (
    <Box sx={{ ...styles, ...cardProps }} {...rest}>
      {children}
    </Box>
  );
};
